exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._1rbJrxSTROs2_m1HbUVYKT{margin-top:48px}.rkudr-67sQ84lP1XpTIMn{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] .rkudr-67sQ84lP1XpTIMn{padding-left:0}html[dir=rtl] .rkudr-67sQ84lP1XpTIMn{padding-right:0}._3OHMTq8E6bt9eS4QtDiMew{font-size:12px}html[dir] ._3OHMTq8E6bt9eS4QtDiMew{margin-top:2px}html[dir=ltr] ._3OHMTq8E6bt9eS4QtDiMew{margin-left:0}html[dir=rtl] ._3OHMTq8E6bt9eS4QtDiMew{margin-right:0}html[dir] .B2YymRFjwdtxS_BA7A4-Z{border-top:1px solid \"[theme:neutralLighter, default:#f4f4f4]\"}", ""]);

// exports
exports.locals = {
	"loadingSpinner": "_1rbJrxSTROs2_m1HbUVYKT",
	"policyCommandButton": "rkudr-67sQ84lP1XpTIMn",
	"icon": "_3OHMTq8E6bt9eS4QtDiMew",
	"policyRowsContainer": "B2YymRFjwdtxS_BA7A4-Z"
};